const Updating = () => (
    <div className="updating-status"><div className="spinner small dark"></div></div>
)

export default Updating;